import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-block" }
const _hoisted_3 = { class: "d-flex justify-content-end mt-5" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "fw-bold mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = { class: "fw-bold mb-2" }
const _hoisted_9 = { class: "d-flex justify-content-between flex-wrap" }
const _hoisted_10 = { class: "fw-bold mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_options_selector = _resolveComponent("options-selector")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_form_field, {
          type: "text",
          modelValue: _ctx.localValue.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.name) = $event)),
          placeholderKey: "Garment name",
          placeholderValue: "Garment name",
          labelKey: "Garment name",
          labelValue: "Garment name"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", {
          class: "form-group pointer w-100 ms-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.localValue.hasExtraPockets = !_ctx.localValue.hasExtraPockets))
        }, [
          _createElementVNode("label", _hoisted_2, [
            _createVNode(_component_localized_text, {
              localizedKey: "Has extra pockets?",
              text: "Has extra pockets?"
            })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localValue.hasExtraPockets}])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-tertiary",
            disabled: !_ctx.localValue.name,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next')))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Continue",
              text: "Continue"
            })
          ], 8, _hoisted_4)
        ]),
        _hoisted_5,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_localized_text, {
              localizedKey: "Phases",
              text: "Phases"
            })
          ]),
          _createVNode(_component_options_selector, {
            modelValue: _ctx.localValue.productionPhases,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.productionPhases) = $event)),
            options: _ctx.phasesTextId,
            keyProp: "identifier",
            labelProp: "text"
          }, null, 8, ["modelValue", "options"])
        ]),
        _hoisted_7,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_localized_text, {
              localizedKey: "Processes",
              text: "Processes"
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue.productionProcesses, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-5 mb-4",
                key: i
              }, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.phase.text), 1),
                _createVNode(_component_options_selector, {
                  modelValue: item.processes,
                  "onUpdate:modelValue": ($event: any) => ((item.processes) = $event),
                  options: _ctx.getProcessesOf(item.phase),
                  keyProp: "identifier",
                  labelProp: "text"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}